import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { Respondent } from '@/types/respondent';

/**
 * Retrieve a respondent object from the API.
 *
 * @param respondentId - The ID of the respondent for whom to fetch answers.
 * @returns A Promise resolving to the Axios response containing the respondent object.
 */
export async function respondentGetQuery(
  respondentId: string
): Promise<AxiosResponse<Respondent>> {
  const requestOptions = {
    method: 'GET',
    params: {
      expand: 'user'
    },
    url: `/respondents/${respondentId}/`
  };
  return api(requestOptions);
}

/**
 * PUT a revised respondent object to the API.
 *
 * @param respondent - The revised respondent object to PUT to the API.
 * @returns A Promise resolving to the Axios response containing the modified respondent object.
 */
export async function respondentPutQuery(
  respondent: Respondent,
): Promise<AxiosResponse<Respondent>> {
  const requestOptions = {
    method: 'PUT',
    url: `/respondents/${respondent?.id}/`,
    data: {
      ...respondent,
      user: respondent.user.id
    }
  };
  return api(requestOptions);
}